import {
  IconCalendarTime,
  IconChevronLeft,
  IconChevronRight,
  IconListDetails,
  IconPrinter,
  IconReload,
  IconSearch,
  IconCloudDownload,
  IconTrash,
  IconRefresh,
} from '@tabler/icons-react';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import DefaultItem from '../components/Admin/DefaultItem';
import { getAuthorizationHeader, http } from '../config/http';
import Layouts from '../layouts/Layouts';
import InputBarang from '../components/Admin/InputBarang';
import DetailItem from './Modal/DetailItem';
import { DateRangePicker } from 'react-date-range';
import moment from 'moment';
import PrintBandrol from '../components/Admin/PrintBandrol';
import { DinamicTitle } from '../utils/DinamicTitle';
import EditItem from './Modal/EditItem';
import Input from '../components/Input';
import ConfirmationDeleteItem from '../components/Admin/ConfirmationDeleteItem';
import { toast } from 'react-toastify';
import useKarat from './features/useKarat';
import usePage from './features/usePage';
import { IconTransferIn, IconBookDownload, IconTransferOut, IconX, IconEye, IconEyeOff } from '@tabler/icons-react';
import TransferBanyakBarang from '../components/Admin/PindahBarangBanyak';
import HapusBanyakBarang from '../components/Admin/HapusBanyakBarang';
import TransferBarangToCabang from '../components/Admin/TransferBarangToCabang';
import useCabang from './features/useCabang';
import LoadingIndicator from '../components/LoadingIndicator';
import PindahBakiBanyak from '../components/Admin/PindahBakiBanyak';

function ListItemAdmin() {
  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  // console.log('items::: ', items);
  const [kategori, setKategori] = useState([]);
  const [page_filter, setPageFilter] = useState([]);

  const [selectedKategori, setSelectedKategori] = useState('');
  const [bakiId, setBakiId] = useState('');
  const [selectJenisKategori, setSelectJenisKategori] = useState('');
  const [totalModal, setTotalModal] = useState(0);
  const [jmlBarang, setJmlBarang] = useState(0);
  const [jmlBerat, setJmlBerat] = useState(0);
  // const [cabang, setCabang] = useState([]);
  const { cabang } = useCabang();

  const [isSubmitItem, setIsSubmitItem] = useState(false);

  const [detailItem, setDetailItem] = useState([]);
  // console.log('detailItem::: ', detailItem);
  const [openLoading, setOpenLoading] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  //   const [openCalender, setOpenCalender] = useState(false);

  let [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageInput, setPageInput] = useState('1');
  const [page, setPage] = useState(0);
  const [selectStatus, setSelectStatus] = useState('');
  const [selectCabang, setSelectCabang] = useState('');

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const awal = moment(startDate).format('DD-MM-YYYY');
  const akhir = moment(endDate).format('DD-MM-YYYY');

  const [openPrintBandrol, setOpenPrintBandrol] = useState(false);
  const [openPindahBanyakBarang, setOpenPindahBanyakBarang] = useState(false);
  const [openHapusBanyakBarang, setOpenHapusBanyakBarang] = useState(false);
  const [openPindahBanyakBaki, setOpenPindahBanyakBaki] = useState(false);
  const [showSelectedPreview, setShowSelectedPreview] = useState(false);
  const [totalModalFilter, setTotalModalFilter] = useState(0);
  const [isEdit, setIsEdit] = useState(false);

  const [deleteId, setDeleteId] = useState('');
  const [barangDelete, setBarangDelete] = useState([]);
  const [loadingDel, setLoadingDel] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const { karatOption, karatOptionId, setKaratOptionId } = useKarat();
  // const [page_filter_loop, setPageFilterLoop] = useState([]);
  const [filterBerat, setFilterBerat] = useState('');

  const [berat, setBerat] = useState('');

  const filterBeratBarang = () => {
    setBerat(filterBerat);
  };

  function refreshPage() {
    window.location.reload(false);
  }

  // ═══ Auto-close Selection Preview ═══
  const previewRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (previewRef.current && !previewRef.current.contains(event.target)) {
        setShowSelectedPreview(false);
      }
    }
    if (showSelectedPreview) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showSelectedPreview]);

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: 'selection',
  };
  function handleSelect(date) {
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
  }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // useEffect(() => {
  //   async function getCabangSelect() {
  //     await http
  //       .get(`cabang`, {
  //         headers: { Authorization: getAuthorizationHeader() },
  //       })
  //       .then((res) => {
  //         setCabang(res.data.data);
  //       })
  //       .catch((err) => {
  //         if (err.response === 'undefined') {
  //           return null;
  //         } else if (err.response.status === 401) {
  //           navigate('/login');
  //         }
  //       });
  //   }
  //   getCabangSelect();
  // }, [navigate]);

  async function getKategori() {
    await http
      .get('/kategori', {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setKategori(res.data);
      })
      .catch((err) => {
        if (err.response === 'undefined') {
          return null;
        } else if (err.response.status === 401) {
          navigate('/login');
        }
      });
  }
  useEffect(() => {
    getKategori();
  }, [navigate]);

  const handleKategoriChange = (event) => {
    setSelectedKategori(event.target.value);
    setSelectJenisKategori('');
  };

  const handleJenisKategoriChange = (event) => {
    setSelectJenisKategori(event.target.value);
  };

  const [search, setSearch] = useState('');
  const [scanInput, setScanInput] = useState('');
  const searchInputRef = useRef(null);
  const scanTimeoutRef = useRef(null);

  async function getItems() {
    const page = `?page=${currentPage}`;
    // const page = (currentPage && page_filter !== '') ? `?page=${page_filter}` : `?page=${currentPage}`;
    setLoading(true);
    await http
      .get(
        `/item${search === '' ? page : `?kode=${search}`}${selectedKategori === '' ? `` : `&kategori=${selectedKategori}`}${selectJenisKategori === '' ? `` : `&jenis_kategori=${selectJenisKategori}`
        }${selectStatus === '' ? `` : `&status=${selectStatus}`}${selectCabang === '' ? `` : `&cabang=${selectCabang}`}${startDate === null && endDate === null ? `` : `&tgl_awal=${awal}&tgl_akhir=${akhir}`
        }${bakiId === '' ? '' : `&no_baki=${bakiId}`}${karatOptionId === '' ? '' : `&karat=${karatOptionId}`}${berat === '' ? '' : `&berat=${berat}`}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        },
      )
      .then((res) => {
        setItems(res.data.data.data);
        setTotalModal(res.data.total_modal);
        setTotalModalFilter(res.data.total_modal_filter);
        setJmlBarang(res.data.data.total);
        setJmlBerat(res.data.total_berat_page);
        setPage(res.data.data.last_page);
        // setPageFilterLoop(res.data.last_page);
        setItemsPerPage(res.data.data.per_page);
        setCurrentPage(res.data.data.current_page);
      })
      .catch((err) => {
        if (err.response === 'undefined') {
          return null;
        } else if (err.response.status === 401) {
          navigate('/login');
        }
      });
    setLoading(false);
  }

  useEffect(() => {
    setPageInput(currentPage.toString());
  }, [currentPage]);

  const handlePageInputChange = (e) => {
    setPageInput(e.target.value);
  };

  const jumpToPage = () => {
    const pageNumber = parseInt(pageInput, 10);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= page) {
      setCurrentPage(pageNumber);
      setSelectedItems([]);
      setSelectPindahItems([]);
      setIsCheckedAll(false);
    } else {
      setPageInput(currentPage.toString());
    }
  };

  const handlePageInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      jumpToPage();
      e.target.blur();
    }
  };

  useEffect(() => {
    getItems();
  }, [
    selectedKategori,
    bakiId,
    isDelete,
    search.length >= 10 ? search : '',
    selectJenisKategori,
    isEdit,
    currentPage,
    selectStatus,
    selectCabang,
    awal,
    akhir,
    isSubmitItem,
    karatOptionId,
    berat,
    page_filter
  ]);
  function closeModal() {
    setIsOpen(false);
  }
  function closeModalDetail() {
    setOpenDetail(false);
  }

  function openModal() {
    setIsOpen(true);
    // console.log('hallo');
  }
  function checkBerat(number) {
    const beratConfirm = parseFloat(number);
    return beratConfirm % 1 === 0
      ? beratConfirm.toString()
      : beratConfirm
        .toFixed(2)
        .replace(/\.?0+$/, '')
        .replace('.', ',');
  }

  const { pageOption, pageOptionId, setPageOptionId } = usePage();

  const [isCheckedAll, setIsCheckedAll] = useState(false);
  const [isCheckedItems, setIsCheckedItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectPindahItems, setSelectPindahItems] = useState([]);

  const resetSelectPindahItems = () => {
    setSelectedItems([]);
    setSelectPindahItems([]);
    setIsCheckedAll(false);
    setIsCheckedItems(items.map(() => false));
  };

  // console.log(selectPindahItems);
  // SELECT CHECKBOX
  function handleCheckboxChange(event, item) {
    if (event.target.checked) {
      // Cek apakah item sudah ada di selectedItems (berdasarkan id)
      const alreadySelected = selectedItems.some((si) => si.id === item.id);
      if (alreadySelected) {
        toast.info('Data ini sudah dipilih sebelumnya.', { autoClose: 2000 });
        event.target.checked = false;
        return;
      }
      setSelectedItems([...selectedItems, item]);
      setSelectPindahItems([...selectPindahItems, item]);
    } else {
      setSelectedItems(selectedItems.filter((si) => si.id !== item.id));
      setSelectPindahItems(selectPindahItems.filter((si) => si.id !== item.id));
    }
  }

  function handleCheckAll(event) {
    setIsCheckedAll(event.target.checked);
    if (event.target.checked) {
      setIsCheckedItems(items.map(() => true));
      setSelectedItems([...items]);
      setSelectPindahItems([...items]);
    } else {
      setIsCheckedItems(items.map(() => false));
      setSelectedItems([]);
      setSelectPindahItems([]);
    }
  }
  // END SELECT CHECKBOX


  // ═══ Barcode Scan Auto-Select ═══
  const handleScanSearch = useCallback(async (kode) => {
    try {
      const res = await http.get(`/item?kode=${kode}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      const foundItems = res.data.data.data;
      if (foundItems && foundItems.length > 0) {
        const item = foundItems[0];
        const alreadySelected = selectedItems.some((si) => si.id === item.id);
        if (alreadySelected) {
          toast.info(`${item.kode_item} sudah dipilih sebelumnya`, { autoClose: 1500 });
        } else {
          setSelectedItems((prev) => [...prev, item]);
          setSelectPindahItems((prev) => [...prev, item]);
          toast.success(`${item.kode_item} berhasil dipilih ✓`, { autoClose: 1500 });
        }
      } else {
        toast.error(`Item dengan kode "${kode}" tidak ditemukan`, { autoClose: 2000 });
      }
    } catch (err) {
      if (err.response?.status === 401) {
        navigate('/login');
      } else {
        toast.error('Gagal mencari item', { autoClose: 2000 });
      }
    } finally {
      // Clear input and refocus for next scan
      setScanInput('');
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }
  }, [selectedItems, navigate]);

  // Trigger scan search when input reaches barcode length
  useEffect(() => {
    if (scanInput.length >= 10) {
      // Small debounce to allow barcode scanner to finish
      if (scanTimeoutRef.current) clearTimeout(scanTimeoutRef.current);
      scanTimeoutRef.current = setTimeout(() => {
        setSearch(scanInput); // Also update search for getItems
        handleScanSearch(scanInput);
      }, 300);
    }
    return () => {
      if (scanTimeoutRef.current) clearTimeout(scanTimeoutRef.current);
    };
  }, [scanInput]);
  function closeModalPrintBandrol() {
    setOpenPrintBandrol(false);
  }
  function closeModalPindahBarangBanyak() {
    setOpenPindahBanyakBarang(false);
  }
  function openModalPindahBarangBanyak() {
    setOpenPindahBanyakBarang(true);
  }
  function openModalPrintBandrol() {
    if (selectedItems.length > 10) {
      toast.error('Maksimal 10 item untuk cetak bandrol');
      return;
    }
    setOpenPrintBandrol(true);
  }


  //ini untuk hapus banyak barang
  //start
  function closeModalHapusBarangBanyak() {
    setOpenHapusBanyakBarang(false);
  }
  function openModalHapusBarangBanyak() {
    setOpenHapusBanyakBarang(true);
  }
  //end


  //ini untuk pindah banyak baki
  //start
  function closeModalPindahBarangBaki() {
    setOpenPindahBanyakBaki(false);
  }
  function openModalPindahBarangBaki() {
    setOpenPindahBanyakBaki(true);
  }
  //end


  function setPageFilterCurrent(val) {
    setCurrentPage(val);
    setPageFilter(val)
  }

  function nextPage() {
    setCurrentPage(currentPage + 1);
    setSelectedItems([]);
    setSelectPindahItems([]);
    setIsCheckedAll(false);
  }

  function prevPage() {
    setCurrentPage(currentPage - 1);
    setSelectedItems([]);
    setSelectPindahItems([]);
    setIsCheckedAll(false);
  }
  DinamicTitle('List Barang || Komaladewi');

  let [isOpenEditItem, setIsOpenEditItem] = useState(false);

  function closeModalEditItem() {
    setIsOpenEditItem(false);
  }

  function openModalEditItem() {
    setIsOpenEditItem(true);
  }

  async function getItemEdit(id) {
    setOpenLoading(true);
    await http
      .get(`item/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setDetailItem(res.data.data);
        openModalEditItem();
      });
    setOpenLoading(false);
  }

  const [filterBaki, setFilterBaki] = useState([]);

  useEffect(() => {
    const numbersArray = [];
    for (let i = 1; i <= 20; i++) {
      numbersArray.push(i);
    }
    setFilterBaki(numbersArray);
  }, []);

  const [itemsPerPage, setItemsPerPage] = useState('');
  const startIndex = (currentPage - 1) * itemsPerPage;

  function showDetailItem(id) {
    // Cari data item dari state items yang sudah di-load di halaman ini
    const selectedItem = items.find(item => item.id === id);
    if (selectedItem) {
      setDetailItem(selectedItem);
      setOpenDetail(true);
    } else {
      toast.error('Data item tidak ditemukan di halaman ini', { autoClose: 2000 });
    }
  }

  let [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  let [isOpenModalPindah, setIsOpenModalPindah] = useState(false);
  const [loadingPin, setLoadingPin] = useState(false);


  function closeModaDelete() {
    setIsOpenModalDelete(false);
  }

  function openModalDelete() {
    setIsOpenModalDelete(true);
  }

  function closeModaPindah() {
    setIsOpenModalPindah(false);
  }

  function openModalPindah() {
    setIsOpenModalPindah(true);
  }

  async function getIdPindahItem(id) {
    setLoadingPin(true);
    await http
      .get(`item/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setDetailItem(res.data.data);
        openModalPindah();
        setLoadingPin(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getIdDelete(id) {
    setLoadingDel(true);
    await http
      .get(`item/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        openModalDelete();
        setDeleteId(res.data.data.id);
        setBarangDelete(res.data.data);
        setLoadingDel(false);
      })
      .catch((err) => {
        console.log(err);
      });
    setLoadingDel(false);
  }
  const [keterangan, setKeterangan] = useState('')
  async function deleteBarang(e) {
    e.preventDefault();
    setIsDelete(true);
    await http
      .post(`item/hapus`, {
        item_id: deleteId,
        keterangan: keterangan
      }, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        closeModaDelete();
        toast.success(res.data.message, { autoClose: 600, });
        // console.log(res)
      })
      .catch((err) => {
        console.log(err);
      });
    setIsDelete(false);
  }

  const user = localStorage.getItem('role');
  const [openModalTransferToToko, setOpenModalTransferToToko] = useState(false)
  function closeOpenModalTransferToToko() {
    setOpenModalTransferToToko(false);
  }
  function reloadDate() {
    getItems();
  }

  return (
    <Layouts
      // title={'List Barang'}
      dateFilter={`${awal === 'Invalid date' ? '' : ` ${awal}`} ${awal === akhir ? `` : `${akhir === 'Invalid date' ? '' : ` s/d ${akhir}`}`}`}
      compFilter={
        <div className="flex items-center gap-1.5">
          <button
            onClick={() => setOpenModalTransferToToko(true)}
            className="px-3 py-2 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white rounded-lg text-sm font-medium shadow-sm hover:shadow transition-all duration-200 flex items-center gap-1.5"
          >
            <IconTransferIn size={18} />
            Transfer
          </button>
          <div className="dropdown dropdown-bottom">
            <div
              tabIndex={0}
              className="bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600 text-white p-2 cursor-pointer rounded-lg shadow-sm hover:shadow transition-all duration-200"
            >
              <IconCalendarTime size={20} />
            </div>
            <div tabIndex={0} className="dropdown-content menu -right-52 p-2 shadow-xl bg-white dark:bg-slate-800 rounded-xl border dark:border-slate-700 z-50">
              <DateRangePicker ranges={[selectionRange]} onChange={handleSelect} />
            </div>
          </div>
          <button
            onClick={() => window.location.reload()}
            className="bg-slate-700 hover:bg-slate-800 text-white p-2 cursor-pointer rounded-lg shadow-sm hover:shadow transition-all duration-200"
          >
            <IconReload size={20} />
          </button>
          <div className="relative group hidden sm:flex">
            <IconSearch size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500 group-hover:text-amber-500 transition-colors" />
            <Input
              ref={searchInputRef}
              value={scanInput}
              onChange={(e) => {
                setScanInput(e.target.value);
                if (e.target.value.length < 10) {
                  setSearch(e.target.value);
                }
              }}
              className="px-3 py-2 text-left input input-bordered w-[160px] lg:w-[220px] rounded-lg pl-9 bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-600 dark:text-slate-200 hover:border-amber-300 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 text-sm shadow-sm transition-all outline-none"
              autoComplete="off"
              type="search"
              name="search"
              placeholder="Scan / Cari Kode Barang"
            />
          </div>
        </div>
      }
      openModal={openModal}
    >
      <ConfirmationDeleteItem
        reloadDate={reloadDate}
        isDelete={isDelete}
        deleteBarang={deleteBarang}
        setKeterangan={setKeterangan}
        barangDelete={barangDelete}
        isOpenModalDelete={isOpenModalDelete}
        closeModaDelete={closeModaDelete}
      />
      <InputBarang
        setIsSubmitItem={() => setIsSubmitItem(true)}
        closeModal={closeModal}
        isOpen={isOpen}
        kategori={kategori}
      />
      <EditItem
        setIsEdit={setIsEdit}
        kategori={kategori}
        cabang={cabang}
        detailItem={detailItem}
        isOpenEditItem={isOpenEditItem}
        closeModalEditItem={closeModalEditItem}
      />
      <DetailItem
        checkBerat={checkBerat}
        detailItem={detailItem}
        closeModalDetail={closeModalDetail}
        openDetail={openDetail}
      />
      {openLoading || loadingDel || loadingPin ? (
        <LoadingIndicator />
      ) : (
        ''
      )}

      {/* ═══ Filter Bar ═══ */}
      <div className="bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm border-b border-amber-100/60 dark:border-slate-700/60 px-3 py-2.5 transition-colors">
        <div className="flex items-center gap-2 w-full overflow-x-auto scrollbar-none">
          <div className="flex items-center gap-1.5 flex-shrink-0">
            {/* Kategori */}
            <select
              value={selectedKategori}
              onChange={handleKategoriChange}
              className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
            >
              <option value="">Kategori</option>
              {kategori.map((kt) => (
                <option key={kt.id} value={kt.id}>
                  {kt.nama_kategori}
                </option>
              ))}
            </select>

            {/* Jenis Kategori */}
            {selectedKategori && (
              <select
                onChange={handleJenisKategoriChange}
                value={selectJenisKategori}
                className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
              >
                <option value="">Jenis Kategori</option>
                {kategori
                  .find((kt) => kt.id === parseInt(selectedKategori))
                  ?.jenis_kategori.map((jk) => (
                    <option key={jk.id} value={jk.id}>
                      {jk.nama_jenis}
                    </option>
                  ))}
              </select>
            )}

            {/* Status */}
            <select
              onChange={(e) => setSelectStatus(e.target.value)}
              className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
            >
              <option value="">Status</option>
              <option value={1}>Tersedia</option>
              <option value={0}>Tidak Tersedia</option>
            </select>

            {/* Baki */}
            <select
              onChange={(e) => setBakiId(e.target.value)}
              className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
            >
              <option value="">Baki</option>
              {filterBaki.map((ftb) => (
                <option value={ftb} key={ftb}>{ftb}</option>
              ))}
            </select>

            {/* Etalase */}
            <select
              onChange={(e) => setSelectCabang(e.target.value)}
              className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
            >
              <option value="">Etalase</option>
              {cabang.map((cb) => (
                <option key={cb.id} value={cb.id}>{cb.nama_cabang}</option>
              ))}
            </select>

            {/* Karat */}
            <select
              onChange={(e) => setKaratOptionId(e.target.value)}
              className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
            >
              <option value="">Karat</option>
              {karatOption.map((kto) => (
                <option value={kto} key={kto}>{kto}</option>
              ))}
            </select>

            {/* Berat Search */}
            <div className="flex items-center gap-1 w-44">
              <Input
                onChange={(e) => setFilterBerat(e.target.value)}
                placeholder="Cari Berat"
                className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-800 dark:text-slate-200 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none w-full"
              />
              <button
                onClick={filterBeratBarang}
                className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 p-2 text-white rounded-lg shadow-sm hover:shadow transition-all duration-200 flex-shrink-0"
              >
                <IconSearch size={18} />
              </button>
            </div>
          </div>

          {/* Action Buttons (right aligned) — only essential tools */}
          <div className="flex items-center gap-1.5 ml-auto flex-shrink-0">
            {user !== 'admin' && (
                <button
                  onClick={openModalPindahBarangBanyak}
                  disabled={selectedItems.length === 0}
                  className={`p-2 cursor-pointer rounded-lg shadow-sm hover:shadow transition-all duration-200 ${selectedItems.length > 0
                    ? 'bg-blue-500 hover:bg-blue-600 text-white'
                    : 'bg-slate-200 dark:bg-slate-700 text-slate-400 dark:text-slate-500 cursor-not-allowed'
                    }`}
                  title={selectedItems.length > 0 ? `Pindah ${selectedItems.length} Barang` : 'Pilih item dulu untuk pindah'}
                >
                  <IconTransferOut size={18} />
                </button>
            )}
            {(user === 'admin' || user === 'owner') && (
                <button
                  onClick={openModalHapusBarangBanyak}
                  disabled={selectedItems.length === 0}
                  className={`p-2 cursor-pointer rounded-lg shadow-sm hover:shadow transition-all duration-200 ${selectedItems.length > 0
                    ? 'bg-red-500 hover:bg-red-600 text-white'
                    : 'bg-slate-200 dark:bg-slate-700 text-slate-400 dark:text-slate-500 cursor-not-allowed'
                    }`}
                  title={selectedItems.length > 0 ? `Hapus ${selectedItems.length} Barang` : 'Pilih item dulu untuk hapus'}
                >
                  <IconTrash size={18} />
                </button>
            )}
            {user !== 'admin' && (
                <button
                  onClick={openModalPindahBarangBaki}
                  disabled={selectedItems.length === 0}
                  className={`p-2 cursor-pointer rounded-lg shadow-sm hover:shadow transition-all duration-200 ${selectedItems.length > 0
                    ? 'bg-emerald-500 hover:bg-emerald-600 text-white'
                    : 'bg-slate-200 dark:bg-slate-700 text-slate-400 dark:text-slate-500 cursor-not-allowed'
                    }`}
                  title={selectedItems.length > 0 ? `Pindah Baki ${selectedItems.length} Barang` : 'Pilih item dulu untuk pindah baki'}
                >
                  <IconRefresh size={18} />
                </button>
            )}
            <button
              onClick={reloadDate}
              className="bg-slate-700 hover:bg-slate-800 text-white p-2 cursor-pointer rounded-lg shadow-sm hover:shadow transition-all duration-200"
              title="Reload Data"
            >
              <IconReload size={18} />
            </button>
            <button
              onClick={openModalPrintBandrol}
              disabled={selectedItems.length === 0}
              className={`p-2 cursor-pointer rounded-lg shadow-sm hover:shadow transition-all duration-200 ${selectedItems.length > 0
                ? 'bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white'
                : 'bg-slate-200 dark:bg-slate-700 text-slate-400 dark:text-slate-500 cursor-not-allowed'
                }`}
              title={selectedItems.length > 0 ? (selectedItems.length > 10 ? 'Maksimal 10 item untuk print' : `Print ${selectedItems.length} Bandrol`) : 'Pilih item dulu untuk print'}
            >
              <IconPrinter size={18} />
            </button>
          </div>
        </div>
      </div>

      {/* ═══ Modals for bulk actions ═══ */}
      <div>
        <PrintBandrol
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          openPrintBandrol={openPrintBandrol}
          closeModalPrintBandrol={closeModalPrintBandrol}
        />
        <TransferBarangToCabang
          openPindahBarangBanyak={openModalTransferToToko}
          setOpenPindahBanyakBarang={setOpenModalTransferToToko}
          reloadDate={reloadDate}
          closeModalBanyakBarang={closeOpenModalTransferToToko}
          selectedItems={selectPindahItems}
          refreshPage={refreshPage}
          setSelectedItems={setSelectPindahItems}
          resetSelectPindahItems={resetSelectPindahItems}
        />
        <TransferBanyakBarang
          cabang={cabang}
          reloadDate={reloadDate}
          selectedItems={selectPindahItems}
          setSelectedItems={setSelectPindahItems}
          openPindahBarangBanyak={openPindahBanyakBarang}
          setOpenPindahBanyakBarang={setOpenPindahBanyakBarang}
          closeModalBanyakBarang={closeModalPindahBarangBanyak}
          refreshPage={refreshPage}
          resetSelectPindahItems={resetSelectPindahItems}
        />

        <HapusBanyakBarang
          cabang={cabang}
          reloadDate={reloadDate}
          selectedItems={selectPindahItems}
          setSelectedItems={setSelectPindahItems}
          openHapusBarangBanyak={openHapusBanyakBarang}
          setOpenHapusBanyakBarang={setOpenHapusBanyakBarang}
          closeModalBanyakBarang={closeModalHapusBarangBanyak}
          refreshPage={refreshPage}
          resetSelectPindahItems={resetSelectPindahItems}
        />

        <PindahBakiBanyak
          reloadDate={reloadDate}
          selectedItems={selectPindahItems}
          setSelectedItems={setSelectPindahItems}
          openPindahBanyakBaki={openPindahBanyakBaki}
          setOpenPindahBanyakBaki={setOpenPindahBanyakBaki}
          closeModalBanyakBarang={closeModalPindahBarangBaki}
          refreshPage={refreshPage}
          resetSelectPindahItems={resetSelectPindahItems}
        />

        {/* ═══ Loading State ═══ */}
        {loading ? (
          <div className="flex items-center justify-center py-16">
            <div className="flex flex-col items-center gap-3">
              <div className="w-10 h-10 border-3 border-amber-200 dark:border-amber-800 border-t-amber-500 dark:border-t-amber-400 rounded-full animate-spin"></div>
              <span className="text-sm font-medium text-slate-500 dark:text-slate-400">Memuat data...</span>
            </div>
          </div>
        ) : (
          /* ═══ Data Table ═══ */
          <div className="relative overflow-x-auto overflow-hidden mx-3 mt-3 mb-16 rounded-xl border border-slate-200/60 dark:border-slate-700/60 shadow-sm">
            <table className="w-full text-sm text-left dark:text-slate-300">
              <thead>
                <tr className="bg-gradient-to-r from-amber-50 via-amber-100/80 to-amber-50 dark:from-amber-900/30 dark:via-amber-800/20 dark:to-amber-900/30">
                  <th scope="col" className="px-3 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                    No
                  </th>
                  <th scope="col" className="px-3 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                    Kode Barang
                  </th>
                  <th scope="col" className="px-4 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                    Nama Barang
                  </th>
                  <th scope="col" className="px-4 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                    Baki
                  </th>
                  <th scope="col" className="px-4 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                    Berat | Karat
                  </th>
                  <th scope="col" className="px-4 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                    Lokasi
                  </th>
                  <th scope="col" className="px-4 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                    Tanggal
                  </th>
                  <th scope="col" className="px-3 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-center">
                    Aksi
                  </th>
                  <th scope="col" className="px-4 py-3 text-center">
                    <input
                      type="checkbox"
                      checked={isCheckedAll}
                      onChange={handleCheckAll}
                      className="cursor-pointer checkbox checkbox-warning w-[18px] h-[18px] border-amber-400 dark:border-slate-500 rounded transition-all"
                      title="Pilih Semua"
                    />
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-slate-700 bg-white dark:bg-slate-900">
                <DefaultItem
                  cabang={cabang}
                  currentPage={currentPage}
                  setSelectedItems={setSelectedItems}
                  startIndex={startIndex}
                  getIdDelete={getIdDelete}
                  getIdPindahItem={getIdPindahItem}
                  page={page}
                  handleCheckboxChange={handleCheckboxChange}
                  selectedItems={selectedItems}
                  checkBerat={checkBerat}
                  showDetailItem={showDetailItem}
                  openModalEditItem={openModalEditItem}
                  getItemEdit={getItemEdit}
                  items={items}
                  search={search}
                  isCheckedItems={isCheckedItems}
                />
              </tbody>
            </table>
          </div>
        )}
        {/* ═══ Floating Quick Action Bar ═══ */}
        {selectedItems.length > 0 && !openPrintBandrol && !openPindahBanyakBarang && !openHapusBanyakBarang && !openPindahBanyakBaki && !openModalTransferToToko && !openDetail && (
          <div ref={previewRef} className="fixed bottom-6 sm:bottom-10 left-1/2 -translate-x-1/2 z-40 w-[95%] sm:w-auto max-w-[600px] animate-[slideUp_0.3s_ease-out]">
            {/* Selected Items Preview Panel */}
            {showSelectedPreview && (
              <div className="mb-2 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md rounded-2xl shadow-2xl border border-amber-200/60 dark:border-slate-600/60 w-full sm:w-[420px] max-h-[280px] overflow-hidden flex flex-col mx-auto">
                <div className="flex items-center justify-between px-3 sm:px-4 py-2 sm:py-2.5 border-b border-slate-100 dark:border-slate-700">
                  <span className="text-xs font-bold text-amber-700 dark:text-amber-400 uppercase tracking-wide">Item Dipilih ({selectedItems.length})</span>
                  <button
                    onClick={() => setShowSelectedPreview(false)}
                    className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors p-1"
                  >
                    <IconX size={16} />
                  </button>
                </div>
                <div className="overflow-y-auto flex-1 divide-y divide-slate-100 dark:divide-slate-700/50">
                  {selectedItems.map((item, idx) => (
                    <div key={item.id} className="flex items-center justify-between px-3 sm:px-4 py-2 hover:bg-amber-50/50 dark:hover:bg-slate-700/30 transition-colors">
                      <div className="flex items-center gap-2 sm:gap-2.5 min-w-0">
                        <span className="text-[10px] font-bold text-slate-400 dark:text-slate-500 w-4 sm:w-5 text-center flex-shrink-0">{idx + 1}</span>
                        <div className="min-w-0">
                          <p className="text-xs font-bold text-slate-700 dark:text-slate-200 truncate">{item.kode_item}</p>
                          <p className="text-[10px] text-slate-400 dark:text-slate-500 truncate">{item.jenis_kategori?.nama_jenis} • {item.berat}gr • {item.karat}krt</p>
                        </div>
                      </div>
                      <button
                        onClick={() => {
                          setSelectedItems(selectedItems.filter((si) => si.id !== item.id));
                          setSelectPindahItems(selectPindahItems.filter((si) => si.id !== item.id));
                        }}
                        className="p-1 text-slate-300 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-all flex-shrink-0 ml-2"
                        title="Hapus dari pilihan"
                      >
                        <IconX size={14} />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="flex items-center gap-2 sm:gap-3 bg-white/90 dark:bg-slate-800/90 backdrop-blur-md rounded-2xl shadow-2xl border border-amber-200/60 dark:border-slate-600/60 px-3 sm:px-5 py-2.5 sm:py-3 w-full overflow-x-auto custom-scrollbar">
              {/* Selection Count - Click to toggle preview */}
              <button
                onClick={() => setShowSelectedPreview(!showSelectedPreview)}
                className="flex items-center gap-1.5 pr-2 sm:pr-3 border-r border-slate-200 dark:border-slate-600 hover:opacity-80 transition-opacity flex-shrink-0"
                title={showSelectedPreview ? 'Tutup daftar' : 'Lihat item dipilih'}
              >
                <span className="bg-amber-500 text-white text-[10px] sm:text-xs font-bold rounded-full w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">{selectedItems.length}</span>
                <span className="text-xs sm:text-sm font-medium text-slate-600 dark:text-slate-300 whitespace-nowrap">item</span>
                {showSelectedPreview ? <IconEyeOff size={14} className="text-slate-400 ml-0.5" /> : <IconEye size={14} className="text-amber-500 ml-0.5" />}
              </button>

              {/* Quick Actions */}
              <div className="flex items-center gap-1 sm:gap-1.5 ml-auto sm:ml-0">
                <button
                  onClick={() => setOpenModalTransferToToko(true)}
                  className="flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 sm:py-2 bg-amber-500 hover:bg-amber-600 text-white text-[11px] sm:text-xs font-semibold rounded-xl shadow-sm hover:shadow transition-all duration-200 whitespace-nowrap"
                  title="Transfer ke Cabang"
                >
                  <IconTransferIn size={14} className="sm:w-4 sm:h-4" />
                  <span className="hidden sm:inline">Transfer</span>
                </button>
                {user !== 'admin' && (
                    <button
                      onClick={openModalPindahBarangBanyak}
                      className="flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 sm:py-2 bg-blue-500 hover:bg-blue-600 text-white text-[11px] sm:text-xs font-semibold rounded-xl shadow-sm hover:shadow transition-all duration-200 whitespace-nowrap"
                      title="Pindah Barang"
                    >
                      <IconTransferOut size={14} className="sm:w-4 sm:h-4" />
                      <span className="hidden sm:inline">Pindah</span>
                    </button>
                )}
                {(user === 'admin' || user === 'owner') && (
                    <button
                      onClick={openModalHapusBarangBanyak}
                      className="flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 sm:py-2 bg-red-500 hover:bg-red-600 text-white text-[11px] sm:text-xs font-semibold rounded-xl shadow-sm hover:shadow transition-all duration-200 whitespace-nowrap"
                      title="Hapus Barang"
                    >
                      <IconTrash size={14} className="sm:w-4 sm:h-4" />
                      <span className="hidden sm:inline">Hapus</span>
                    </button>
                )}
                {user !== 'admin' && (
                    <button
                      onClick={openModalPindahBarangBaki}
                      className="flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 sm:py-2 bg-emerald-500 hover:bg-emerald-600 text-white text-[11px] sm:text-xs font-semibold rounded-xl shadow-sm hover:shadow transition-all duration-200 whitespace-nowrap"
                      title="Pindah Baki"
                    >
                      <IconRefresh size={14} className="sm:w-4 h-4" />
                      <span className="hidden sm:inline">Baki</span>
                    </button>
                )}
                <button
                  onClick={openModalPrintBandrol}
                  className="flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 sm:py-2 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white text-[11px] sm:text-xs font-semibold rounded-xl shadow-sm hover:shadow transition-all duration-200 whitespace-nowrap"
                  title="Print Bandrol"
                >
                  <IconPrinter size={14} className="sm:w-4 sm:h-4" />
                  <span className="hidden sm:inline">Print</span>
                </button>
              </div>

              {/* Clear Selection */}
              <div className="pl-2 sm:pl-3 border-l border-slate-200 dark:border-slate-600 flex-shrink-0">
                <button
                  onClick={() => {
                    setSelectedItems([]);
                    setSelectPindahItems([]);
                    setIsCheckedAll(false);
                    setIsCheckedItems(items.map(() => false));
                    setShowSelectedPreview(false);
                  }}
                  className="p-1.5 sm:p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-xl transition-all duration-200"
                  title="Batal Pilih Semua"
                >
                  <IconX size={14} className="sm:w-4 sm:h-4" />
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ═══ Footer: Summary + Pagination ═══ */}
        <div className="bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm bottom-0 left-0 py-2.5 px-4 w-full absolute border-t border-amber-100/60 dark:border-slate-700/60 transition-colors">
          <div className="flex items-center justify-between">

            {/* Desktop Summary */}
            <div className="lg:flex hidden items-center gap-5">
              <div className="flex items-center gap-2 bg-gradient-to-r from-amber-50 to-amber-100/50 dark:from-slate-800 dark:to-slate-800/50 rounded-lg px-3.5 py-2 border border-amber-200/40 dark:border-slate-700">
                <span className="text-xs font-semibold text-amber-700 dark:text-amber-400 uppercase tracking-wide">Modal</span>
                <span className="text-sm font-bold text-slate-800 dark:text-slate-200">
                  Rp {numberWithCommas(totalModal === totalModalFilter ? totalModal : totalModalFilter)}
                </span>
              </div>
              <div className="flex items-center gap-2 bg-gradient-to-r from-amber-50 to-amber-100/50 dark:from-slate-800 dark:to-slate-800/50 rounded-lg px-3.5 py-2 border border-amber-200/40 dark:border-slate-700">
                <span className="text-xs font-semibold text-amber-700 dark:text-amber-400 uppercase tracking-wide">Barang</span>
                <span className="text-sm font-bold text-slate-800 dark:text-slate-200">{jmlBarang}</span>
              </div>
              <div className="flex items-center gap-2 bg-gradient-to-r from-amber-50 to-amber-100/50 dark:from-slate-800 dark:to-slate-800/50 rounded-lg px-3.5 py-2 border border-amber-200/40 dark:border-slate-700">
                <span className="text-xs font-semibold text-amber-700 dark:text-amber-400 uppercase tracking-wide">Berat</span>
                <span className="text-sm font-bold text-slate-800 dark:text-slate-200">{jmlBerat} gr</span>
              </div>
            </div>

            {/* Mobile Summary */}
            <div className="dropdown dropdown-top lg:hidden">
              <div
                tabIndex={0}
                className="bg-gradient-to-r from-amber-500 to-amber-600 cursor-pointer hover:from-amber-600 hover:to-amber-700 hover:shadow-md p-2 text-white rounded-lg shadow-sm transition-all duration-200"
              >
                <IconListDetails size={20} />
              </div>
              <div tabIndex={0} className="dropdown-content menu p-4 shadow-xl bg-white dark:bg-slate-800 rounded-xl w-[320px] border border-amber-100 dark:border-slate-700">
                <div className="space-y-3">
                  <div className="flex items-center justify-between pb-2.5 border-b border-slate-100 dark:border-slate-700">
                    <span className="text-sm font-semibold text-amber-700 dark:text-amber-400 uppercase">Modal</span>
                    <span className="text-sm font-bold text-slate-800 dark:text-slate-200">
                      Rp {numberWithCommas(totalModal === totalModalFilter ? totalModal : totalModalFilter)}
                    </span>
                  </div>
                  <div className="flex items-center justify-between pb-2.5 border-b border-slate-100 dark:border-slate-700">
                    <span className="text-sm font-semibold text-amber-700 dark:text-amber-400 uppercase">Total Barang</span>
                    <span className="text-sm font-bold text-slate-800 dark:text-slate-200">{jmlBarang} barang</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-semibold text-amber-700 dark:text-amber-400 uppercase">Total Berat</span>
                    <span className="text-sm font-bold text-slate-800 dark:text-slate-200">{jmlBerat} gram</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Pagination */}
            <div className="flex items-center gap-2.5">
              <span className="text-xs font-medium text-slate-500 dark:text-slate-400 flex items-center gap-1.5">
                Halaman
                <input
                  type="text"
                  value={pageInput}
                  onChange={handlePageInputChange}
                  onBlur={jumpToPage}
                  onKeyDown={handlePageInputKeyDown}
                  className="w-12 h-7 text-center border border-slate-200 dark:border-slate-600 rounded-md bg-white dark:bg-slate-800 text-amber-700 dark:text-amber-400 font-bold focus:border-amber-400 focus:ring-1 focus:ring-amber-200 outline-none transition-all"
                />
                dari <span className="font-bold text-amber-700 dark:text-amber-400">{page}</span>
              </span>
              <div className="flex items-center gap-1">
                <button
                  onClick={prevPage}
                  disabled={currentPage < 2}
                  title="previous"
                  type="button"
                  className="inline-flex items-center justify-center w-8 h-8 border border-slate-200 dark:border-slate-600 rounded-lg shadow-sm hover:bg-amber-50 dark:hover:bg-slate-800 hover:border-amber-300 dark:hover:border-amber-600 hover:text-amber-600 dark:hover:text-amber-400 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200"
                >
                  <IconChevronLeft size={16} />
                </button>
                <button
                  onClick={nextPage}
                  disabled={currentPage >= page}
                  title="next"
                  type="button"
                  className="inline-flex items-center justify-center w-8 h-8 border border-slate-200 dark:border-slate-600 rounded-lg shadow-sm hover:bg-amber-50 dark:hover:bg-slate-800 hover:border-amber-300 dark:hover:border-amber-600 hover:text-amber-600 dark:hover:text-amber-400 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200"
                >
                  <IconChevronRight size={16} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layouts>
  );
}

export default ListItemAdmin;
